import { mutations } from './layout.d';

export default {
  /**
   * Update Modal Status (Open, or Close)
   */
  [mutations.updateModalStatus](state, payload) {
    state.modal[payload.module] = payload.status;
  }
};
